<template>
  <div class="form-tabs">
    <ul class="form-tabs-nav">
      <li
        v-for="(tab, index) in tabs"
        :key="`${tab.title}-${index}`"
        :class="{ active: activeIndex === index }"
        @click="navigateTo(index)"
      >
        <span class="form-tab-title">{{ tab.title }}</span>
        <span v-if="tab.indicator" :class="tab.indicator">*</span>
      </li>
    </ul>

    <div class="form-tabs-body">
      <slot />
    </div>

    <div class="form-tabs-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTabs',
  props: {
    // index tab aktif (0-based), dipakai sebagai controlled value
    value: {
      type: Number,
      default: 0,
    },
    // fungsi pengaman sebelum pindah tab; return false untuk membatalkan
    beforeChange: {
      type: Function,
      default: null,
    },
  },
  provide() {
    return {
      formTabs: this,
    }
  },
  data() {
    return {
      tabs: [],
      activeIndex: this.value,
    }
  },
  watch: {
    value(val) {
      this.activeIndex = val
    },
  },
  methods: {
    addTab(tab) {
      this.tabs.push({ instance: tab, title: tab.title, indicator: tab.indicator })
      return this.tabs.length - 1
    },
    removeTab(tab) {
      const index = this.tabs.findIndex((entry) => entry.instance === tab)
      if (index > -1) this.tabs.splice(index, 1)
    },
    updateIndicator(tab, indicator) {
      const entry = this.tabs.find((item) => item.instance === tab)
      if (entry && entry.indicator !== indicator) entry.indicator = indicator
    },
    // method pusat untuk perpindahan tab
    async navigateTo(index) {
      if (index < 0 || index >= this.tabs.length) return
      if (index === this.activeIndex) return
      if (this.beforeChange && (await this.beforeChange(index)) === false) return
      this.activeIndex = index
      this.$emit('input', index) // untuk v-model (opsional)
      this.$emit('change', index) // method handler di parent menerima ini
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/app';

.form-tabs-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;

  > li {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1rem;
    border-radius: $border-radius;
    background-color: $gray-300;
    cursor: pointer;

    .form-tab-title {
      color: $text-color;
    }

    &.active {
      background-color: theme-color('primary');

      .form-tab-title {
        color: #fff;
      }
    }
  }
}

.form-tabs-body {
  margin-top: 0.5rem;
}

/* root FormTab (child) ikut ter-style karena scoped Vue menandai root child */
.form-tab-content {
  background-color: $gray-200;
  border-radius: $border-radius;
  padding: 1rem;
}
</style>
